import { Tooltip } from 'antd';
import React from 'react'
import { ActionLockedIconWithTooltipWrapper, LockIconWrapper, TooltipCompWrapper } from './ActionLocked.styles';
import { ReactComponent as LockIcon } from './icons/LockIcon.svg';
import { ReactComponent as UnlockIconTooltip } from './icons/unlock-icon.svg';
import { observer } from 'mobx-react';
import { useStore } from '../../../modules/app/data/root.store';
import { CalendlyPopupWidget } from '../CalendlyPopupWidget/CalendlyPopupWidget';
export const ActionLockedIconWithTooltip = observer(({ iconColor, marginTop, marginLeft, isRoleBlocked, placement, isItemClosed }) => {
  const { userStore } = useStore();

  return (
    <ActionLockedIconWithTooltipWrapper marginLeft={marginLeft}>
      <Tooltip placement={placement || 'top'}
        overlayInnerStyle={{ borderRadius: '6px', background: 'rgba(0, 0, 0, 0.9)' }}
        title={<TooltipComp isRoleBlocked={isRoleBlocked} actionBlockedByRolePrompt={userStore.actionBlockedByRolePrompt} isItemClosed={isItemClosed} isB2BUser={userStore.isB2BUser} />}>
        <LockIconWrapper marginTop={marginTop} iconColor={iconColor}>
          <LockIcon />
        </LockIconWrapper>
      </Tooltip>
    </ActionLockedIconWithTooltipWrapper>
  )
})

const TooltipComp = ({ isRoleBlocked, actionBlockedByRolePrompt, isItemClosed, isB2BUser }) => {
  return (
    <TooltipCompWrapper onClick={(e) => { e.stopPropagation() }} withLineBreak={isRoleBlocked}>
      {isRoleBlocked ? null : <LockIconWrapper iconColor={'white'}>
        <UnlockIconTooltip />
      </LockIconWrapper>}
      {isItemClosed ?
        'Edit events and Info is not available when item is closed'
        : (isRoleBlocked ?
          isB2BUser ? <div>
            This is a Demo Account with view-only access.
            Want full access?
            <CalendlyPopupWidget
              triggerComponent={<span style={{ textDecoration: 'underline', color: '#1890ff', cursor: 'pointer' }}>Schedule a call</span>}
              triggerWrapperStyles={{ display: 'inline', marginInline: '4px' }}
            />
            to build your real dashboard.
          </div>
            : actionBlockedByRolePrompt
          : 'Unlock with Vyzer Membership')}
    </TooltipCompWrapper>
  )
}